module.exports = __webpack_public_path__ + "img/lit_booth.f353d29b.png";